import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { Dashboard } from '@/api/REST/dashboards';
import { IconedLabel } from '@/components/ui/IconedLabel';
import { uiIcons } from '@/constants/uiIcons';
import { useLocaleStore } from '@/stores/locale';
import { formatDate } from '@/utils/date';

export const DashboardCreatedProperty = ({
  dashboardData,
}: {
  dashboardData: Dashboard;
}) => {
  const { lang } = useLocaleStore();
  const { t } = useTranslation('dashboard');

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <IconedLabel iconName={uiIcons.metadata.created} iconColor="secondary">
        {t('HeaderProperties.Created')}
      </IconedLabel>
      <Typography variant="labelMono" component="p">
        {formatDate(dashboardData.createdAt, lang)}
      </Typography>
    </Stack>
  );
};
